import React, { useState, useEffect } from "react";
import { SessionStudentResultStatusEnum } from "constants/enums/SessionStudentResultStatusEnum";
import IconLoader from "components/IconLoader/IconLoader";
import { RankTypeEnum } from "constants/exam/RankTypeEnum";

export default function SessionStudentResult({ resultObject }) {
  const [branchList, setBranchList] = useState([]);
  const [metricList, setMetricList] = useState([]);
  useEffect(() => {
    const newBranchList = [];
    const newMetricList = [];
    if (resultObject?.examAssesmentDO) {
      resultObject?.examAssesmentDO?.formList?.forEach((form) => {
        form?.lessonList?.forEach((branches) => {
          if (branches.subLessonList.length > 0) {
            branches.subLessonList.forEach((sub) => {
              newBranchList.push(sub);
            });
          } else {
            newBranchList.push(branches);
          }
        });
        form?.scoreList?.forEach((score) => {
          if (
            score?.scoreMetricId !== "62ea5c32cd4c5f7e44721c66" &&
            score?.scoreMetricId !== "62fa66447951c7414c723388" &&
            score?.scoreMetricId !== "678668db7438b001941483ec"
          ) {
            //YKS-SÖZ, LG-SÖZ ve KSCVP metriği gözükmemesi için
            const schoolRank = resultObject?.examAssesmentDO?.ranks?.find(
              (rank) => rank.metricId === score?.scoreMetricId && rank.type === RankTypeEnum.SCHOOL
            );
            const campusRank = resultObject?.examAssesmentDO?.ranks?.find(
              (rank) => rank.metricId === score?.scoreMetricId && rank.type === RankTypeEnum.CAMPUS
            );
            const generalRank = resultObject?.examAssesmentDO?.ranks?.find(
              (rank) => rank.metricId === score?.scoreMetricId && rank.type === RankTypeEnum.GENERAL
            );

            newMetricList.push({
              id: score?.scoreMetricId,
              name: score?.scoreMetricName,
              score: schoolRank?.score || generalRank?.score || null,
              [RankTypeEnum.SCHOOL]: {
                rank: schoolRank?.rank || null,
                count: schoolRank?.count || null
              },
              [RankTypeEnum.CAMPUS]: {
                rank: campusRank?.rank || null,
                count: campusRank?.count || null
              },
              [RankTypeEnum.GENERAL]: {
                rank: generalRank?.rank || null,
                count: generalRank?.count || null
              }
            });
          }
        });
      });
    }
    setMetricList(newMetricList);
    setBranchList(newBranchList);
  }, [resultObject]);

  return (
    <>
      {resultObject?.status !== SessionStudentResultStatusEnum.BEFORE_EXAM_DATE &&
        resultObject?.status !== SessionStudentResultStatusEnum.NOT_EVALUATED && (
          <div className="w-100 container mt-6 border-top border-secondary border-3">
            <div className="d-flex justify-content-center my-4">
              <h1>{resultObject?.examAssesmentDO?.examName} / Sınav Sonucu</h1>
            </div>
            {resultObject?.status === SessionStudentResultStatusEnum.SCHOOL_SETTING_NOT_EXIST ? (
              <div className="d-flex w-100 justify-content-center pt-10 pb-10">
                <span className="h6">
                  {resultObject?.message ||
                    "Sevgili öğrencimiz. Sınav sonuç karneni almak, detaylı analizini görüşmek üzere seni kurumumuza bekliyoruz. Başarılar dileriz."}
                </span>
              </div>
            ) : (
              <>
                <div className="d-flex justify-content-center my-4">
                  <span className="h6">
                    {resultObject?.message ? (
                      resultObject?.message
                    ) : (
                      <>
                        {resultObject?.examSessionSettingDO?.showMessage &&
                          resultObject?.examSessionSettingDO?.message?.length > 0 &&
                          (resultObject?.examSessionSettingDO?.message || "")}
                      </>
                    )}
                  </span>
                </div>

                {(resultObject?.examSessionSettingDO?.showRanks ||
                  resultObject?.examSessionSettingDO?.showScore ||
                  resultObject?.examSessionSettingDO?.showGeneralRank ||
                  resultObject?.examSessionSettingDO?.showCampusRanks ||
                  resultObject?.examSessionSettingDO?.showSchoolAttendanceCount ||
                  resultObject?.examSessionSettingDO?.showCampusAttendanceCount ||
                  resultObject?.examSessionSettingDO?.showGeneralAttendanceCount) && (
                  <>
                    {metricList?.map((metric, index) => (
                      <div
                        className="d-flex text-white p-2 shadow mb-4 mr-2"
                        key={index + metric?.id}
                        style={{
                          background: "#773CF6",
                          borderRadius: 18
                        }}
                      >
                        <div className="d-flex flex-fill flex-column align-items-center mx-8">
                          <IconLoader icon="mdiStarOutline" size={1.7} />
                          <span style={{ color: "#A197E6" }}>Puan Türü</span>
                          <span>{metric?.name}</span>
                        </div>
                        <div className="lms-br-gradient" style={{ width: 1 }}></div>
                        <div className="d-flex flex-fill flex-column align-items-center mx-8">
                          <IconLoader icon="mdiWeb" size={1.7} />
                          <span style={{ color: "#A197E6" }}>Puan</span>
                          <span>{metric?.score ? parseFloat(metric?.score).toFixed(2) : "-"}</span>
                        </div>

                        <div className="lms-br-gradient" style={{ width: 1 }}></div>
                        <div className="d-flex flex-fill flex-column align-items-center mx-8">
                          <IconLoader icon="mdiStar" size={1.7} />
                          <span style={{ color: "#A197E6" }}>Kurum</span>
                          <span style={{ color: "#A197E6" }}>(Derece/Katılımcı)</span>
                          <span>
                            {metric[RankTypeEnum.SCHOOL]?.rank || "-"}/
                            {metric[RankTypeEnum.SCHOOL]?.count || "-"}
                          </span>
                        </div>
                        <div className="lms-br-gradient" style={{ width: 1 }}></div>
                        <div className="d-flex flex-fill flex-column align-items-center mx-8">
                          <IconLoader icon="mdiStar" size={1.7} />
                          <span style={{ color: "#A197E6" }}>Kampüs</span>
                          <span style={{ color: "#A197E6" }}>(Derece/Katılımcı)</span>
                          <span>
                            {metric[RankTypeEnum.CAMPUS]?.rank || "-"}/
                            {metric[RankTypeEnum.CAMPUS]?.count || "-"}
                          </span>
                        </div>
                        <div className="lms-br-gradient" style={{ width: 1 }}></div>
                        <div className="d-flex flex-fill flex-column align-items-center mx-8">
                          <IconLoader icon="mdiStar" size={1.7} />
                          <span style={{ color: "#A197E6" }}>Genel</span>
                          <span style={{ color: "#A197E6" }}>(Derece/Katılımcı)</span>

                          <span>
                            {metric[RankTypeEnum.GENERAL]?.rank || "-"}/
                            {metric[RankTypeEnum.GENERAL]?.count || "-"}
                          </span>
                        </div>
                      </div>
                    ))}
                  </>
                )}

                {resultObject?.examSessionSettingDO?.showCWEN && (
                  <div className="my-6 p-4" style={{ background: "#E8E5FA", borderRadius: 16 }}>
                    <div
                      className="d-flex rounded mb-2 p-2"
                      style={{
                        border: "1px solid #BFD2F2",
                        background: "#EFEEFC",
                        fontWeight: 600
                      }}
                    >
                      <div className="w-50">Dersler</div>
                      <div className="w-50 d-flex">
                        <div className="flex-fill text-center" style={{ flex: 1, width: 0 }}>
                          Soru Sayısı
                        </div>
                        <div className="flex-fill text-center" style={{ flex: 1, width: 0 }}>
                          Doğru
                        </div>
                        <div className="flex-fill text-center" style={{ flex: 1, width: 0 }}>
                          Yanlış
                        </div>
                        <div className="flex-fill text-center" style={{ flex: 1, width: 0 }}>
                          Net
                        </div>
                      </div>
                    </div>
                    {branchList.map((branch) => {
                      return (
                        <div
                          key={branch?.lessonId}
                          className="d-flex rounded mb-2 p-2"
                          style={{
                            border: "1px solid #BFD2F2",
                            background: "#EFEEFC"
                          }}
                        >
                          <div className="w-50">{branch?.lessonName}</div>
                          <div className="w-50 d-flex">
                            <div className="flex-fill text-center" style={{ flex: 1, width: 0 }}>
                              {branch?.questionCount || "-"}
                            </div>
                            <div className="flex-fill text-center" style={{ flex: 1, width: 0 }}>
                              {branch?.numberofCorrectAnswer || "-"}
                            </div>
                            <div className="flex-fill text-center" style={{ flex: 1, width: 0 }}>
                              {branch?.numberofWrongAnswer || "-"}
                            </div>
                            <div className="flex-fill text-center" style={{ flex: 1, width: 0 }}>
                              {parseFloat(branch?.numberofNet)?.toFixed(2) || "-"}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                    <div
                      className="d-flex rounded mb-2 p-2"
                      style={{
                        border: "1px solid #BFD2F2",
                        background: "#EFEEFC",
                        fontWeight: 600
                      }}
                    >
                      <div className="w-50">Toplam</div>
                      <div className="w-50 d-flex">
                        <div className="flex-fill text-center" style={{ flex: 1, width: 0 }}>
                          {branchList?.reduce(
                            (prev, branch) => (branch?.questionCount || 0) + prev,
                            0
                          )}
                        </div>
                        <div className="flex-fill text-center" style={{ flex: 1, width: 0 }}>
                          {branchList?.reduce(
                            (prev, branch) => (branch?.numberofCorrectAnswer || 0) + prev,
                            0
                          )}
                        </div>
                        <div className="flex-fill text-center" style={{ flex: 1, width: 0 }}>
                          {branchList?.reduce(
                            (prev, branch) => (branch?.numberofWrongAnswer || 0) + prev,
                            0
                          )}
                        </div>
                        <div className="flex-fill text-center" style={{ flex: 1, width: 0 }}>
                          {parseFloat(
                            branchList?.reduce(
                              (prev, branch) => (branch?.numberofNet || 0) + prev,
                              0
                            )
                          )?.toFixed(2)}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        )}
    </>
  );
}
